export default class FormComponentState {
  public data: {
    [key: string]: any,
  }

  constructor() {
    this.data = {}
  }
}
